<template>
  <div>
    <GenerateDepositModal :branchId="branchId" />
    <MasterLayout>
      <div class="dashboard_first_row pt-4 pb-3 pl-4 pr-4">
        <div class="row align-items-center white-bg py-3">
          <div class="col-md-1 remove-right-padding col-center-flex">
            <div class="square-icon-wrapper small sky-bg">
              <img src="@/assets/img/bank-building (2).svg" width="35" />
            </div>
          </div>
          <div class="col-md-8">
            <h4 class="primary-color font-600">
              {{ $t("text.bBankDeposit.title") }}
            </h4>
            <p class="light-grey-text mt-3">
              {{ $t("text.bBankDeposit.genTitle") }}, <br />
              {{ $t("text.bBankDeposit.description") }}
            </p>
          </div>
          <div class="col-md-3">
            <button
              class="ep-btn ep-primary"
              @click="showModal('generateDepositModal')"
            >
              {{ $t("text.bBankDeposit.genDeposit") }}
            </button>
          </div>
        </div>
      </div>
      <section class="pump__details__section_2">
        <div class="row add_driver_row record__expenses">
          <div class="col-md-12 col-lg-5 mt-3" style="padding-right: 0px">
            <div class="drivers_list"></div>
          </div>
          <div class="col-md-12 mt-3 text-center">
            <ejs-grid
              v-show="!showLoader"
              ref="dataGrid"
              :created="refreshGrid"
              :allowPaging="true"
              :allowSorting="true"
              :pageSettings="pageSettings"
              :toolbar="toolbar"
              :searchSettings="search"
              :allowExcelExport="true"
              :allowPdfExport="true"
              :toolbarClick="toolbarClick"
              :excelQueryCellInfo="excelQueryCellInfo"
              :allowTextWrap="true"
              :locale="usedLang"
              :rowDataBound="rowDataBound"
            >
              <e-columns>
                <e-column width="40" field="index" headerText="#"></e-column>
                <e-column
                  field="date"
                  :format="formatOptions"
                  type="date"
                  width="190"
                  :headerText="$t('text.bBankDeposit.dateRec')"
                ></e-column>
                <e-column
                  field="amount"
                  format="N2"
                  width="180"
                  :headerText="`${$t('text.bBankDeposit.amount')} (${
                    branch ? branch.currency : ''
                  })`"
                ></e-column>
                <e-column
                  width="180"
                  field="reference"
                  :headerText="$t('text.bBankDeposit.reference')"
                ></e-column>
                <e-column
                  field="status"
                  width="180"
                  :headerText="$t('text.iOrderDetails.status')"
                ></e-column>
              </e-columns>
            </ejs-grid>
            <TableLoader :showLoader="showLoader"></TableLoader>
          </div>
        </div>
      </section>
    </MasterLayout>
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Branch/MasterLayout.vue";
import backgroundUrl from "@/assets/img/Credit-card-background-shallow-DOF.png";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index.vue";
import GenerateDepositModal from "@/components/modals/generateDepositModal.vue";

import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
  Resize,
} from "@syncfusion/ej2-vue-grids";
import JQuery from "jquery";
let $ = JQuery;

export default {
  name: "Pump_Details",
  components: {
    MasterLayout,
    TableLoader,
    GenerateDepositModal,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport, Resize],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      file: [],
      expenseCategoryId: "select category",
      formatOptions: { type: "date", format: "dd/MM/yyyy" },
      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      customShortcuts: [
        { key: "Today", label: this.$t("text.calendar.today"), value: "day" },
        {
          key: "yesterday",
          label: this.$t("text.calendar.yesterday"),
          value: "-day",
        },
        {
          key: "last7Days",
          label: this.$t("text.calendar.last7Days"),
          value: 7,
        },
        {
          key: "lastWeek",
          label: this.$t("text.calendar.lastWeek"),
          value: "-isoWeek",
        },
        {
          key: "last30Days",
          label: this.$t("text.calendar.last30Days"),
          value: 30,
        },
        {
          key: "lastMonth",
          label: this.$t("text.calendar.lastMonth"),
          value: "-month",
        },
      ],
      startDate: this.$moment().subtract(7, "days").format("MMMM D, YYYY"),
      endDate: this.$moment().format("MMMM D, YYYY"),
      pluginStartDate: this.$moment().subtract(7, "days").format("D-M-YYYY"),
      pluginEndDate: this.$moment().format("D-M-YYYY"),
      dateRange: { start: this.pluginStartDate, end: this.pluginEndDate },
      pumpId: this.$route.query.id,
      pump: {},
      tanks: [],
      description: null,
      amount: null,
      paymentMode: "cash",
      accountNumber: "select account",
      backgroundUrl,
      expenses: null,
      formIsValid: false,
      isButtonDisabled: false,
      showLoader: true,
      branch: {},
      branchId: null,
      bankAccounts: null,
      expenseCategories: [],
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
      userDetails: localStorage.getItem("userDetails")
        ? JSON.parse(localStorage.getItem("userDetails"))
        : null,
      deleteTemplate: function () {
        return {
          template: Vue.component("columnTemplate", {
            template:
              '<button class="delete_btn" v-on:click="removeExpenses(data.id)">Delete</button>',
            data: function () {
              return {
                data: {},
              };
            },
            methods: {
              removeExpenses: function (id) {
                this.$eventHub.$emit("deleteBranchExpenses", id);
              },
            },
          }),
        };
      },

      accountId: "select bank",
      banks: [],
      scheduleDateTime: "",
      showRef: false,
      reference: "",
    };
  },
  created() {
    // this.showLoader = true
    this.$eventHub.$on("branch", (branch) => {
      this.branch = branch;
      document.title = `Bank deposit :: ${branch.name} Retail Outlet`;
    });
    this.$eventHub.$on("deleteBranchExpenses", (id) => {
      this.deleteExpenses(id);
    });
    this.$eventHub.$on("fetchReferences", (id) => {
      this.getReferences(id);
    });

    this.dateRange.start = this.pluginStartDate;
    this.dateRange.end = this.pluginEndDate;
    document.title = "Expenses :: Epump Retail Outlet";
  },
  beforeDestroy() {},
  watch: {
    branch: function (newBranch, oldBranch) {
      if (newBranch.id) {
        this.branchId = this.branch.id;
        if (this.branchId !== null) {
          this.getBanks();
          this.getToday();
          this.getReferences();
          $(".e-input").keyup(function (e) {
            searchFun(e);
          });
          function searchFun(event) {
            var grid =
              document.getElementsByClassName("e-grid")[0].ej2_instances[0];
            var value = event.target.value;
            grid.search(value);
          }
        }
      }
    },
    dateRange: function (newRange, oldRange) {
      if (newRange.start !== null && newRange.end !== null) {
        this.startDate = this.$moment(newRange.start, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.endDate = this.$moment(newRange.end, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );

        this.getReferences();
      }
    },
  },
  mounted() {},
  methods: {
    rowDataBound: function (args) {
      args.row.cells[4].style.color = "#E49204";
    },
    showModal(modal) {
      this.$modal.show(modal);
    },
    getToday() {
      let d = new Date(),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      var hours = d.getHours();
      var minutes = d.getMinutes();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      hours = hours < 10 ? "0" + hours : hours;
      var strTime = hours + ":" + minutes + " " + ampm;

      let todaysDate = [year, month, day].join("-") + " " + strTime;
      this.scheduleDateTime = todaysDate;
    },
    getBanks() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/BankAccounts/${this.branchId}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.banks = response.data;
        })
        .catch((error) => {});
    },
    excelQueryCellInfo(args) {
      if (args.column.field == "date") {
        args.value = this.$moment(args.value).format("DD/MM/YYYY hh:mm A");
      }
    },
    captureFormEvents($event) {
      if ($event.target.placeholder === this.$t("text.bExpenses.amount")) {
        if ($event.target.value === "") {
          this.$refs.amount_error.style.display = "block";
          this.$refs.amount_error.innerHTML = this.$t(
            "text.bExpenses.amountMissing"
          );
          this.$refs.amount_input_div.style.border = "1px solid red";
          this.$refs.amount_error.style.color = "red";
          this.formIsValid = false;
        } else {
          this.$refs.amount_error.style.display = "none";
          this.$refs.amount_error.innerHTML = "";
          this.$refs.amount_error.style.display = "none";
          this.$refs.amount_input_div.style.border =
            "1px solid rgb(75, 44, 114)";
          this.formIsValid = true;
        }
      }
      if ($event.target.placeholder === this.$t("text.bExpenses.description")) {
        if ($event.target.value === "") {
          this.$refs.description_error.style.display = "block";
          this.$refs.description_error.innerHTML = this.$t(
            "text.bExpenses.descriptionMissing"
          );
          this.$refs.description_input_div.style.border = "1px solid red";
          this.$refs.description_error.style.color = "red";
          this.formIsValid = false;
        } else {
          this.$refs.description_error.style.display = "none";
          this.$refs.description_error.innerHTML = "";
          this.$refs.description_input_div.style.border =
            "1px solid rgb(75, 44, 114)";
          this.formIsValid = true;
        }
      }
    },
    generateDeposit($event) {
      $event.preventDefault();
      if (!this.amount) {
        this.$toast.open({
          message: this.$t("text.bBankAccounts.amountRequired"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (this.accountId == "select bank") {
        this.$toast.open({
          message: this.$t("text.bBankAccounts.bankAccountRequired"),
          type: "error",
          duration: 3000,
        });
        return;
      }

      const dateTime = this.$moment(`${this.scheduleDateTime}`).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      let newDateTime = new Date(dateTime);
      let updatedDateTime = new Date(
        newDateTime.setHours(newDateTime.getHours() + 1)
      ).toISOString();
      let date = updatedDateTime;

      const data = {
        accountId: this.accountId,
        amount: parseFloat(this.amount),
        date: date,
      };

      this.isButtonDisabled = true;
      $(".loader").show();
      this.axios
        .post(
          `${configObject.apiBaseUrl}/Branch/DepositReference/${this.branchId}`,
          data,
          configObject.authConfig()
        )
        .then((res) => {
          this.reference = res.data;
          this.showRef = true;

          this.getReferences();
          this.$toast.open({
            message: this.$t("text.bBankDeposit.depositSuccess"),
            type: "success",
            duration: 2000,
          });
          $(".loader").hide();
          this.isButtonDisabled = false;
          this.accountId = "select bank";
          this.amount = null;
        })
        .catch(() => {
          this.$toast.open({
            message: this.$t("text.requests.failure"),
            type: "error",
            duration: 5000,
          });
          $(".loader").hide();

          this.isButtonDisabled = false;
        });
    },
    changeRoute($newRoute) {
      this.$router.push({ name: $newRoute });
    },
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    getReferences() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/DepositReferences/${this.branchId}`,
          configObject.authConfig()
        )
        .then((response) => {
          let index = 0;
          response.data.forEach((element) => {
            element.index = ++index;
          });
          this.showLoader = false;
          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: response.data,
          });
          this.refreshGrid();
        })
        .catch((error) => {});
    },
    convertThousand(request) {
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>
